import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import React, { useEffect, useRef, useState } from 'react';
import ONS_NUTS from './regions.json';
import './Map.css';
import * as turf from "@turf/turf";

mapboxgl.accessToken =
'pk.eyJ1IjoicmJha2VyLWJhcmJvdXJhYmkiLCJhIjoiY2wwc2I4Y2VrMDJtZzNqbHp3Mnh6ODdlZCJ9.R1YvEK_gMgkMHiFhew8iIA';


const Map = ( { selectedRegion, setSelectedRegion  }) => {

    const mapContainerRef = useRef(null);
    const [lng, setLng] = useState(-3.7082);
    const [lat, setLat] = useState(55);
    const [zoom, setZoom] = useState(5);
    const [pitch, setPitch] = useState(0);
  
    // Initialize map when component mounts
    useEffect(() => {
      const map = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: 'mapbox://styles/mapbox/light-v10?optimize=true',
        center: [lng, lat],
        zoom: zoom,
        pitch: pitch,
        // maxBounds:[
        //   [-25,  40], // Southwest coordinates
        //   [15, 80] // Northeast coordinates
        //   ]
      });

      // Change zoom depending on window size 
      var mq = window.matchMedia( "(min-width: 420px)" );

      if (mq.matches){
          map.setZoom(5); //set map zoom level for desktop size
      } else {
        map.setZoom(4.5); //set map zoom level for mobile size
        map.setCenter([-3.5, 53.5]);
      };


      map.on('load', () => {

        map.addSource('Regions', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: ONS_NUTS.features,
          },
        });
    
        map.addLayer({
          id: 'Regions-line',
          type: 'line',
          source: 'Regions',
          "paint": {
            'line-color': '#fdb913',
            'line-opacity': 1,
            'line-width': 1.5
            }
    
        }
        );
    
        map.addLayer({
          id: 'Regions-fill',
          type: 'fill',
          source: 'Regions',
          "paint": {
            'fill-color': '#fdb913',
            'fill-opacity': 0.1,
            }
    
        }
        )});


  map.on('click', 'Regions-fill', (e) => { 
    
    const region = e.features[0].properties.Name;

    setSelectedRegion(...[region]);

    var bbox = turf.bbox(turf.truncate(e.features[0]));

    map.fitBounds(bbox, {maxZoom: 7.5, speed: 2});

    map.setPaintProperty('Regions-fill', 'fill-opacity', ['match', ['get', 'Name'], region, 0.5, 0.1]);

    });

    map.on('click', 'Regions-fill', function(e) {
      e.preventDefault();
    });

    map.on('click', function(e) {
      if (e.defaultPrevented === false) {
        setSelectedRegion(...['']);
        map.setPaintProperty('Regions-fill', 'fill-opacity', 0.1);

      }
    });
  


  // Change the cursor to a pointer when the mouse is over the places layer.
  map.on('mouseenter', 'Regions-fill', () => {
    map.getCanvas().style.cursor = 'pointer';
    });
      
  // Change it back to a pointer when it leaves.
  map.on('mouseleave', 'Regions-fill', () => {
  map.getCanvas().style.cursor = '';
  });


  map.addControl(
    new mapboxgl.NavigationControl(),
     'top-right');



  map.on('move', () => {
    setLng(map.getCenter().lng.toFixed(4));
    setLat(map.getCenter().lat.toFixed(4));
    setZoom(map.getZoom().toFixed(2));
    setPitch(map.getPitch().toFixed(2)); 
  });

        // Clean up on unmount
        return () => map.remove();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
  
    return (
      <div>

          

          <div className="map-container" ref={mapContainerRef} />

          {/* <div className="region-test">
            <p> {selectedRegion}  </p>
            </div> */}
          
      </div>
    

    ) ;
  } ;
  
  export default Map;